<template>
    <div class="card-container">
        <div class="card">
            <div class="front-content">
                <p>COMPLIANCE</p>
            </div>
            <div class="content">
                <p class="heading">COMPLIANCE WEB</p>
                <p>
                    Nuestra plataforma de detección del delito ofrece un sistema completo, para cumplir con la Ley
                    20.393. Este software permite supervisar, identificar y reaccionar a actividades delictivas en
                    tiempo real, utilizando inteligencia artificial y análisis de datos avanzados.
                </p>
            </div>
        </div>
    </div>
</template>
<script>
import config from '@/plugins/config';

export default {
    name: 'TitleProjectCard',
    computed: {
        menuBgColor() {
            return config.theme.menuBackgroundColor;
        },
        lighterBgColor() {
            // Convert hex to RGB, lighten it, and return as hex
            const hex = config.theme.menuBackgroundColor.replace('#', '');
            const r = parseInt(hex.substring(0, 2), 16);
            const g = parseInt(hex.substring(2, 4), 16);
            const b = parseInt(hex.substring(4, 6), 16);

            // Lighten by adding 30 to each component (max 255)
            const lighterR = Math.min(255, r + 30);
            const lighterG = Math.min(255, g + 30);
            const lighterB = Math.min(255, b + 30);

            // Convert back to hex
            return `#${lighterR.toString(16).padStart(2, '0')}${lighterG.toString(16).padStart(2, '0')}${lighterB.toString(16).padStart(2, '0')}`;
        }
    }
}
</script>
<style scoped>
.card-container {
    width: 100%;
    height: 250px;
    position: relative;
    border-radius: 10px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
    overflow: hidden;
}

.card {
    width: 100%;
    height: 100%;
    border-radius: inherit;
    position: relative;
}

.card .front-content {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.6s cubic-bezier(0.23, 1, 0.320, 1)
}

.card .front-content p {
    text-align: justify;
    font-size: 32px;
    font-weight: 700;
    opacity: 1;
    background: linear-gradient(-45deg, v-bind(menuBgColor) 0%, v-bind(lighterBgColor) 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    transition: all 0.6s cubic-bezier(0.23, 1, 0.320, 1)
}

.card .content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 10px;
    background: linear-gradient(-45deg, v-bind(lighterBgColor) 0%, v-bind(menuBgColor) 100%);
    color: #e8e8e8;
    padding: 20px;
    line-height: 1.5;
    border-radius: 5px;
    pointer-events: none;
    transform: translatex(96%);
    transition: all 0.6s cubic-bezier(0.23, 1, 0.320, 1);
}

.card .content .heading {
    font-size: 32px;
    font-weight: 700;
}

.card:hover .content {
    transform: translateY(0);
}

.card:hover .front-content {
    transform: translateX(20%);
}

.card:hover .front-content p {
    opacity: 0;
}


</style>